"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var sizeIconUI = _a.sizeIconUI;
  return {
    base: {
      display: 'inline-block',
      whiteSpace: 'nowrap',
      position: 'relative'
    },
    baseOverflowText: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '115px'
    },
    baseList: {
      paddingLeft: '20px'
    },
    text: {
      paddingLeft: '10px'
    },
    arrow: {
      position: 'absolute',
      left: '0px'
    },
    icon: {
      width: sizeIconUI,
      height: '11px'
    }
  };
};